import $ from 'jquery';
import {deliveryDelete} from "../queries";
import {Cache, changeObjectKeys, Cookie} from "../utilities";
import Popup from "../utilities/Popup";
import lodash from "lodash";

$('body').on('click', '.js-personal-delivery-show-add', function () {
    const $addForm = $('.page-personal-delivery-form');
    $addForm.find('.page-personal-delivery-form__title').html('Добавить адрес');
    $addForm.find('[name="delivery_courier_operation_type"]').val('add');
    const constInputVariable = ['delivery_kind','page_type','delivery_courier_operation_type']
    $addForm.fadeIn();
    $addForm.find('input').val(function () {
        if (this.type === 'checkbox') {
            $(this).prop('checked', false);
        }

        if (constInputVariable.includes(this.name)) {
            return $(this).val();
        }
        return null;
    });
    $('html, body').animate({
        scrollTop: $(".js-form-personal-delivery-save").offset().top-300 // класс объекта к которому приезжаем
    }, 1);
});

$('body').on('click', '.page-personal-delivery-form__close', function () {
    $('.page-personal-delivery-form').css('display', 'none');
});


$('body').on('click', '.js-delivery-update', function () {
    let dataElements = '';
    const $form = $('.js-form-personal-delivery-save');
    const $addForm = $('.page-personal-delivery-form');
    $addForm.find('.page-personal-delivery-form__title').html('Изменить адрес');

    if ($(this).hasClass('ui-radio-beauty-item--delivery')) {
        dataElements = $(this).find('.js-delivery-update').data();
    } else {
        $addForm.fadeIn();
        dataElements = $(this).data();
    }
    $form.find('input').val(function (index, value) {
        $(this).parent().addClass('ui-input--filled')
        if (this.type === 'checkbox' && dataElements['delivery_courier_is_main']) {
            $(this).prop('checked', true);
            $(this).val("1");
            return;
        } else {
            $(this).prop('checked', false);
        }

        if (this.name === 'page_type') {
            return $(this).val();
        }
        return dataElements[this.name];
    });
    $addForm.find("input[name*='delivery_courier_operation_type']").val('update');

    $('html, body').animate({
        scrollTop: $(".js-form-personal-delivery-save").offset().top-300 // класс объекта к которому приезжаем
    }, 1);
});

$('body').on('click', '.js-delivery-delete', async function () {
    const dataElements = $(this).data();
    const response = await deliveryDelete(dataElements);

    const $form = $('.js-page-order-panel__hidden-delivery-form');
    const params = changeObjectKeys(response.mainAddress, lodash.snakeCase)
    if (response.mainAddress){
        $form.find('input').val(function () {
            if (this.name === 'comment'){
                return params['delivery_courier_comment']['value'];
            }
            return params[this.name]['value'];
        });
    }else {
        $form.find('input').val(function () {
            return null;
        });
    }

    const $addresses = $('.page-order-form__delivery-items, .page-personal-delivery__items');
    $addresses.toggleClass('page-personal-delivery__items--loading');
    if (response.status === 'success') {
        $(this).parent().remove();
        $('.page-personal-delivery__items, .page-order-form__delivery-items').html(response.component)
    }
    $addresses.toggleClass('page-personal-delivery__items--loading');
});

$('body').on('click', '.page-order-form__delivery-items .ui-radio-beauty', async function () {
    const $form = $('.js-page-order-panel__hidden-delivery-form');
    const dataElements = $(this).find('.js-delivery-update').data();
    $form.find('input').val(function () {
        if (this.name === 'comment') {
            return dataElements['delivery_courier_comment'];
        }
        return dataElements[this.name];
    });
});


$('.js-form-personal-delivery-save').on('change', async function () {
    $(this).find('button').removeClass('ui-button--disabled').removeAttr('disabled');
});

$('.js-form-personal-delivery-authorize').on('submit', async function (e) {
    e.preventDefault();
    const serializedAarray = $(this).serializeJSON();

    if (!serializedAarray.delivery_courier_address || serializedAarray.delivery_courier_address.length < 1){
        Popup.notify('Пожалуйста, заполните адрес доставки.','Ошибка');
    }else{
        Cookie.set('DELIVERY_AUTHORIZE', $(this).serializeJSON(), 360000);
        Popup.showContent('Адрес', 'Адрес сохранён! Пожалуйста, авторизуйтесь для оформления заказа.', 700, true);
    }
});
